/*
 * @Author: huangzq
 * @Date: 2020-04-13 20:23:04
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-08 17:46:05
 * @Desc: 课程编辑or新建对应的表单数据
*/

import StatusRadio from './status-radio'
import CourseListMaterial from './course-list-material'

export const FormGlobalConfig = {
  labelWidth: '90px'

}

export const FormRules = {
  'name.value': [
    { required: true, message: '请输入课程名称', trigger: 'blur' }
  ]
}

export const FormSchema = {
  name: {
    // 当前字段类型
    type: 'string',
    // 当前字段的值，v-model使用
    value: '',
    // 当前字段的默认值，重置时使用
    defaultValue: '',
    // el-form-item的包含的组件，完全自定义的
    ui: {
      label: '课程名称：',
      placeholder: '请输入名称',
      // 组件名
      widget: 'MkInput',
      // 组件配置
      widgetConfig: {
        width: '370',
        maxlength: '20',
        showWordLimit: true
      }
    }
  },
  tags: {
    type: 'Array',
    value: [],
    defaultValue: [],
    ui: {
      label: '课程标签：',
      placeholder: '选择标签（多选）',
      widget: 'TagSelect',
      widgetConfig: {
        width: '370',
        tip: false,
        maxNum: 0
      }
    }
  },
  status: {
    type: 'number',
    value: 1,
    defaultValue: 1,
    ui: {
      label: '状态：',
      widget: StatusRadio, // 组件名
      // 组件配置
      widgetConfig: {
        width: '370',
        // 初始化数据
        data: [{
          value: 1,
          label: '启用'
        }, {
          value: 2,
          label: '停用'
        }]
      }
    }
  },
  description: {
    type: 'string',
    value: '',
    defaultValue: '',
    ui: {
      label: '课程说明：',
      placeholder: '请输入课程说明',
      widget: 'MkInput',
      widgetConfig: {
        type: 'textarea',
        width: '370',
        height: '100',
        maxlength: '50',
        resize: 'none',
        showWordLimit: true
      }
    }
  },
  courseWares: {
    type: 'Array',
    value: [],
    defaultValue: [],
    ui: {
      label: '课件：',
      widget: CourseListMaterial,
      widgetConfig: {
      }
    }
  }
}
